import React from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import { Box } from 'components/layout/Box/Box'
import { List } from 'components/shared/List/List'
import { SnackbarContent } from './common/SnackbarContent/SnackbarContent'

import styles from './Snackbar.module.scss'

const DEFAULT_SPACING = 62.5

// TransitionGroup passes `in` and `onExited` to each child, so the item hands
// them on to CSSTransition. The item keeps its own node ref, without which
// react-transition-group falls back to the deprecated findDOMNode
const SnackbarItem = ({
  delay,
  index,
  snack: { id, message, type },
  onDismiss,
  ...transitionProps
}) => {
  const ref = React.useRef<HTMLLIElement>(null)

  return (
    <CSSTransition
      {...transitionProps}
      className={styles.snackbar}
      classNames={{
        enter: styles.enter,
        enterActive: styles.enterActive,
        exit: styles.exit,
        exitActive: styles.exitActive,
      }}
      nodeRef={ref}
      timeout={delay}
    >
      <List.Item
        role="presentation"
        style={{ bottom: `${index * DEFAULT_SPACING}px` }}
        {...{ ref }}
      >
        <Box className={styles.content}>
          <SnackbarContent {...{ id, message, type, onDismiss }} />
        </Box>
      </List.Item>
    </CSSTransition>
  )
}

export const Snackbar = ({ delay = 200, snacks, onDismiss }) => (
  <List>
    <TransitionGroup>
      {snacks.map((snack, index) => (
        <SnackbarItem key={snack.id} {...{ delay, index, snack, onDismiss }} />
      ))}
    </TransitionGroup>
  </List>
)
